export const IdentitiesPath = "/identities";
export const IdentityNewPath = `${IdentitiesPath}/manage/new`;
export const IdentityMinorPath = `${IdentitiesPath}/manage/minor`;
export const IdentityEditPath = `${IdentitiesPath}/manage/edit`;
export const KycSignaturePath = `${IdentitiesPath}/kyc/signature`;
export const SuitabilityTestRenewalPath = `${IdentitiesPath}/suitabilityTest`;
export const SuitabilityTestRenewalConfirmPath = `${SuitabilityTestRenewalPath}/confirm`;

/**
 * Estado de navegación hacia la renovación del test de idoneidad.
 * El id del interviniente viaja por estado, no por la URL (anti-IDOR, igual que la firma del KYC).
 */
export interface SuitabilityTestRenewalNavigationState
{
    userIdentityId?: number;
    userIdentityName?: string;
}

/**
 * Parámetro heredado del enlace antiguo del aviso de cesión aprobada (`/identities/manage/edit/{id}?acceptTransfer=1`).
 * El aviso ya enlaza sin él: el formulario de aceptación lo decide el estado TRANSFER del interviniente. Si llega
 * sobre un interviniente que no está en TRANSFER, la edición lo quita de la URL.
 */
export const AcceptTransferQueryParam = "acceptTransfer";

export function hasAcceptTransferParam(search: string | null | undefined): boolean
{
    return new URLSearchParams(search ?? "").get(AcceptTransferQueryParam) === "1";
}

/** Querystring sin el parámetro acceptTransfer, conservando el resto (p. ej. el deep-link de contrato). */
export function removeAcceptTransferParam(search: string | null | undefined): string
{
    const params = new URLSearchParams(search ?? "");
    params.delete(AcceptTransferQueryParam);
    const remaining = params.toString();
    return remaining !== "" ? `?${remaining}` : "";
}

/**
 * Contexto de contrato de las pantallas de intervinientes. Viaja por estado de navegación y no por la
 * URL: hay una sola ruta de intervinientes, sin espejo bajo /contract/:savingsPlanId.
 */
export interface IdentitiesContractNavigationState
{
    contractSavingsPlanId?: number;
}

export type IdentitiesListNavigationState = IdentitiesContractNavigationState &
{
    savedSuccessMessage?: string;
    suitabilityLimitMessage?: string;
};

/** Estado con el que se vuelve al listado: conserva el contexto de contrato y los avisos. */
export function buildIdentitiesListNavigationState(contractSavingsPlanId?: number, savedSuccessMessage?: string, suitabilityLimitMessage?: string): IdentitiesListNavigationState | undefined
{
    if(contractSavingsPlanId == null && !savedSuccessMessage && !suitabilityLimitMessage)
    {
        return undefined;
    }

    return{
        contractSavingsPlanId: contractSavingsPlanId,
        savedSuccessMessage: savedSuccessMessage,
        suitabilityLimitMessage: suitabilityLimitMessage,
    };
}
